import { FC } from 'react'

import { ResolvedAdSettings } from '@sportworld/js-sdk/src/types/servicesTypes/configTypes'

import { SettingsHeader } from '@/components/SettingsHeader'
import HlsAdsPlayer from '@/components/VideoPlayer/HlsAdsPlayer'
import { focusIds } from '@/constants/focus'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import { SettingsContainer } from '../styles'
import { ContentContainer } from '../Usercentrics/styles'

type Props = {
  title: string
}

const src =
  'https://b1smarttv-nativewaves-3.amagi.tv/stream7/sw02/data/master.m3u8'
// 'https://amg00622-amg00622c7-sportworld-europe-2599.playouts.now.amagi.tv/playlist/amg00622-sportworld-de-sportworldeurope/playlist.m3u8?w=1440&h=869&cb=26022249&app_bundle=com.b1smarttv.sportworld&app_name=Sportworld&app_store_url=https://play.google.com/store/apps/details?id=com.b1smarttv.sportworld&url=http://localhost:3000/broadcast/sw$statsperform-pressbox?tabIndex=0&ic=IAB17&content_categories=IAB17,IAB17-44&content_livestream=0&gdpr=0&gdpr_consent=&us_privacy=&dnt=0&lmt=0&ap=1&mute=1&rating=TV-G&skip=0&placement=1&prodq=1&coppa=0&network_name=Sportworld&ifa_type=dpid&did=&ssid=&ttd_uid2=&genre=Sports,Soccer'
// 'https://vod.performgroup.com/transcoded/20250926/260925_DE_SPN_STEINER_UBER_HORNER_VERSTAPPEN_ITV_1758874775228-1_1724.mp4'

const preRollAdUrl =
  'https://player.glomex.com/ad-vault/v2/inline/linear/glomex/preroll.xml?test_csai_param=REPLACE_ME&us_privacy=REPLACE_ME'
// 'https://tv.springserve.com/rt/91980?w=1920&h=1080&cb=44646394&ip=217.119.77.134&ua=Mozilla/5.0%20(Macintosh;%20Intel%20Mac%20OS%20X%2010_15_7)%20AppleWebKit/537.36%20(KHTML,%20like%20Gecko)%20Chrome/137.0.0.0%20Safari/537.36&lat=52.2491&lon=20.978&dnt=0&ic=REPLACE_ME&dur=REPLACE_ME&ap=1&pod_max_dur=30&pod_ad_slots=0-20,0-20&app_bundle=not%20supported&app_name=Sportworld&app_store_url=https://seller.samsungapps.com/tv/tizen-application/distribute/3201903018105&content_id=elf-beyond-the-huddle$ep2&content_title=ELF%20Beyond%20The%20Huddle&content_genre=REPLACE_ME&content_livestream=0&content_categories=REPLACE_ME&channel_name=elf%20live%20g1&content_custom_1_param=pre-roll&content_custom_2_param=b1smarttv&language=de-DE&network_name=Sportworld&did=not%20supported&device_make=apple&device_model=not%20supported&brand_name=apple&country=DE&ifa_type=tifa&gdpr_consent=CQRgQAAQRgQAAAFADBENBrFsAP_gAEPgAAYgJzQJ4AFAAWABAACoAIIATgBRACwALQAZAA0AB4AEKAIwAjgBMACcAFuAMIAxABzAEAAIQARgAygBqgDiAIQAR0AkoBOAC6gI1AWGAvYBf4DGQGWANrAgKBBoCQQEvQJzAnNASAAWABUAEAAMgAaAA8ACOAEwAMQAfgBCADKAIQAR0AkoC_wGWATmAAAA.f_wACHwAAAAA&gdpr=1&us_privacy=REPLACE_ME&coppa=REPLACE_ME&lmt=0'

const adSettings: ResolvedAdSettings = {
  ssaiUrlParameters: 'test_ssai_param=1',
  csaiSettings: {
    preRollAdUrl,
  },
  // csaiAdUrl: // TODO: PROPOSAL
  //   'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpremidpostpod&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&cmsid=496&vid=short_onecue&correlator=&us_privacy=REPLACE_ME',
}

export const SettingsPage: FC<Props> = ({ title = 'Settings Page Title' }) => {
  const focusId = `Generic${focusIds.SETTINGS}${focusIds.CONTAINER_MOD}`
  const { t } = useCommonTranslation()

  return (
    <SettingsContainer focusId={focusId} elementType="div" isTrap>
      <SettingsHeader title={t(title)} />
      <ContentContainer>
        <div style={{ width: '1280px', height: '720px', position: 'relative' }}>
          <HlsAdsPlayer src={src} adSettings={adSettings} />
        </div>
      </ContentContainer>
    </SettingsContainer>
  )
}
